
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.am-media-d5 .media-video-d5').forEach(function(wrapper) {
    const video = wrapper.querySelector('video');
    if (!video) return;
    const btn = wrapper.querySelector('.media-overlay-d5');

    btn.addEventListener('click', function() {
      // pause any other playing video
      document.querySelectorAll('.am-media-d5.playing video').forEach(function(v) {
        if (v !== video) {
          v.pause();
          v.closest('.am-media-d5').classList.remove('playing');
        }
      });

      if (video.paused) {
        video.play();
        wrapper.closest('.am-media-d5').classList.add('playing');
      } else {
        video.pause();
        wrapper.closest('.am-media-d5').classList.remove('playing');
      }
    });

    // optional: remove class when video ends
    video.addEventListener('ended', function() {
      wrapper.closest('.am-media-d5').classList.remove('playing');
    });
  });

  // Tabs Function
  d5Tabs();

  function d5Tabs (){
    const buttons = document.querySelectorAll('.t-tab-button-d5');
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
      const tabId = btn.getAttribute('data-id');
      buttons.forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.t-tab-card-d5').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(tabId).classList.add('active');
    })
    })
  }
});
